import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import VCalendar from 'v-calendar';
import 'v-calendar/dist/style.css';
import { auth } from '@/firebase'; // Import Firebase auth module
import { onAuthStateChanged } from 'firebase/auth'; // Import the listener

// Create the Vue app instance but DO NOT mount it yet.
const app = createApp(App);

// Use plugins as normal.
app.use(store);
app.use(router);
app.use(VCalendar, {});

// A flag to ensure we only mount the app once.
let appMounted = false;

// onAuthStateChanged listens for the initial auth state AND any subsequent changes.
onAuthStateChanged(auth, async (user) => {
  // We dispatch our new action to process the user state.
  await store.dispatch('handleAuthStateChange', user);

  // Mount the app only after the first auth check is complete.
  if (!appMounted) {
    app.mount('#app');
    appMounted = true;
  }
});